<template>
<div class="chapter">
<div class="inner_page">
<div class="wrap">
<p class="image"><a id="page_11"></a><img alt="image" class="vertical" src="images/f0011-01.jpg"/></p>
</div>
<h1 class="section_title"><a id="page_12"></a><a id="for"></a>Foreword</h1>
<p class="text_noindent">I will always remember the first time I met Julia Turshen. She was catering a party for my dearest friends and when she walked into the room, it simply lit up. I’m not sure if it was her brilliant smile, infectious laugh, or that gorgeous wild hair but the whole picture is truly memorable. She went on to make an amazingly delicious and earthy dinner for all of us, but it was only later when she and I became friends that I came to really understand Julia’s special brand of magic.</p>
<p class="text_indent">Julia’s love of two things come together in this book—her total delight in great food and she adores cooking for people she loves. She spent a decade as a private chef and coauthoring some of the best cookbooks around. But this book is pure Julia; the recipes she makes for Grace and their friends are ones that we all want to make at home. They’re simple to prepare but have great bold flavors.</p>
<p class="text_indent">Julia’s book is like her—it’s totally accessible. She explains a few unusual ingredients at the beginning, and everything else is available at the grocery store. I adore her notes for recipes like Doug’s meat loaf (Doug’s her dad) and ways you can “spin-off” each recipe into your own. Julia is a cook who not only trusts her recipes but also her readers. I can’t wait to cook my way through this amazing new book, and I’ll definitely be starting with those raspberry jam buns!</p>
<p class="right">—Ina Garten</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007-foreword.vue?37489f88